// @flow
import * as React from 'react'
import { config, Hidden } from 'react-awesome-styled-grid'
import MediaSlider from '@components/home/PressMediaSlider'
import UserQuotesSlideCarousel from '@components/home/UserQuotesSlideCarousel'
import styled from 'styled-components'
import { colors } from '@components/shared/colors'
import DriveToDownloadBlock from '@components/DriveToDownloadBlock'
import { DipseaContentfulAssets } from '@components/shared'
import type { BottomCarouselType } from '../../services/contentfulMarketingLandingPages'
import UserQuotesSlider from '@components/UserQuotesSlider'
import SectionBackgroundImageParallax from './ContentBlocks/SectionBackgroundImageParallax'

export default function CarouselAndDriveToDownloadSection (props: {
  pageId: string,
  carouselType: BottomCarouselType
}): React.Node {
  if (props.carouselType === 'None') {
    return null
  }

  return (
    <Section isNoPadding={!!(props.carouselType === 'Only Drive To Download')}>
      {props.carouselType === 'Press Quotes Cards' && (
        <MediaSlider cardColor={colors.cobalt} />
      )}
      {props.carouselType === 'User Quotes Cards' && (
        <UserQuotesSlider
          title={`We give 'em something \n to talk about.`}
          backgroundColor={colors.cobalt}
        />
      )}
      {props.carouselType === 'User Quotes Slides' && (
        <UserQuotesSlideCarousel />
      )}

      <DriveToDownLoadContainer>
        <DriveToDownloadBlock />
      </DriveToDownLoadContainer>

      <Hidden xs={false} sm={false} md={true} lg={true} xl={true}>
        <SectionBackgroundImageParallax
          uniqueId='marketing-drive-to-download-mobile'
          backgroundColor={colors.midnightBlue}
          imageUrl={DipseaContentfulAssets['marketing-landing-bottom-mobile']}
          height={374}
          width={819}
        />
      </Hidden>
      <Hidden xs={true} sm={true} md={false} lg={false} xl={false}>
        <SectionBackgroundImageParallax
          uniqueId='marketing-drive-to-download-desktop'
          backgroundColor={colors.midnightBlue}
          imageUrl={DipseaContentfulAssets['marketing-landing-bottom-desktop']}
          height={2048 * 2}
          width={2222 * 2}
        />
      </Hidden>
    </Section>
  )
}

const Section = styled.section`
  overflow: hidden;
  position: relative;
  padding: ${(props: { isNoPadding: boolean}): string => props.isNoPadding ? '0' : '70px 0 0'};
  ${(props: any): string => config(props).media.md`
    padding: ${(props: { isNoPadding: boolean }): string => props.isNoPadding ? '0' : '120px 0 0'};
  `}
`
const DriveToDownLoadContainer = styled.div`
  margin: 90px 0 70px;
  ${(props: any): string => config(props).media.md`
    margin: 100px 0 70px;
  `}
  ${(props: any): string => config(props).media.lg`
    margin: 145px 0 100px;
  `}
`
